<template>
  <div>
    <van-grid :column-num="n" clickable :border="false" :center="false">
      <van-grid-item v-for="mi in list" :key="mi.ItemName" @click="cmdMI(mi)">
        <div style="text-align: center">
          <ImgItem
            :src="mi.ImgFile"
            :qty="getItemQty(mi)"
            v-if="soldOut(mi)"
            class="sold-out"
          />
          <ImgItem :src="mi.ImgFile" :qty="getItemQty(mi)" v-else />
          <div class="text-size">{{ mi.DispName }}</div>
          <!-- <div class="text-size" v-html="gNl2br(mi.DispName)" /> -->
          <div v-if="!soldOut(mi)" class="C1">${{ mi.Price1 }}</div>
          <van-tag v-if="soldOut(mi)" round type="primary" size="large" color="#999"
            >售完</van-tag
          >
          <div v-if="gGetDcText(mi)">
            <span class="tag">{{ gGetDcText(mi) }}</span>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<style scoped>
v .van-image {
  width: 6rem;
  height: 6rem;
  border-radius: 3rem;
}
.sold-out {
  /* background-color: rgba(1, 1, 1, 0.6); */
  filter: grayscale(100%);
}
</style>

<script>
import ImgItem from "./ImgItem.vue";
export default {
  components: {
    ImgItem,
  },
  props: {
    bkmenu: Object,
    ordertmp: Array,
    list: Array,
    n: Number,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    soldOut(item) {
      var find = this.sStopSale.find((r) => r.ItemName == item.ItemName);
      if (find) {
        return true;
      }
      return false;
    },
    getItemQty(item) {
      const ordertmp = this.$store.state.sOrdertmp;
      if (ordertmp == undefined) return 0;
      var array = ordertmp.filter(
        (r) => r.TypeNo == item.TypeNo && r.ItemName == item.ItemName
      );
      return this.gSum(array, "Qty");
    },
    cmdMI(obj) {
      var find = this.sStopSale.find((r) => r.ItemName == obj.ItemName);
      if (find) {
        return this.gMsgbox("此項目已售完");
      }

      this.$emit("click", obj);
    },
  },
};
</script>
